import {
  NotBlankString__toString_impl_5tex9r2ig2s5isyc5ve as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj41ooh7w2aare6h as NotBlankString__hashCode_impl_fxqzj4,
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg316j9v81zgqwq as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var PartyIdClass;
function PartyId() {
  if (PartyIdClass === VOID) {
    class $ {
      constructor(value) {
        this.e2d_1 = value;
      }
      toString() {
        return 'PartyId(value=' + NotBlankString__toString_impl_5tex9r(this.e2d_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.e2d_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PartyId()))
          return false;
        if (!(this.e2d_1 === other.e2d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PartyId');
    PartyIdClass = $;
  }
  return PartyIdClass;
}
var PartyElementClass;
function PartyElement() {
  if (PartyElementClass === VOID) {
    class $ {
      constructor(partyId, element) {
        this.u2a_1 = partyId;
        this.v2a_1 = element;
      }
      toString() {
        return 'PartyElement(partyId=' + this.u2a_1.toString() + ', element=' + toString(this.v2a_1) + ')';
      }
      hashCode() {
        var result = this.u2a_1.hashCode();
        result = imul(result, 31) + (this.v2a_1 == null ? 0 : hashCode(this.v2a_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PartyElement()))
          return false;
        if (!this.u2a_1.equals(other.u2a_1))
          return false;
        if (!equals(this.v2a_1, other.v2a_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PartyElement');
    PartyElementClass = $;
  }
  return PartyElementClass;
}
function with_0(_this__u8e3s4, element) {
  return new (PartyElement())(_this__u8e3s4, element);
}
function PartyId_0(value) {
  // Inline function 'kotlin.getOrThrow' call
  var this_0 = toNotBlankString(value);
  throwOnFailure(this_0);
  var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).v28_1;
  return new (PartyId())(tmp$ret$0);
}
//region block: exports
export {
  PartyElement as PartyElement3pvi4n0tmyceb,
  PartyId_0 as PartyId3nezlril92b5k,
  PartyId as PartyId30onj62xl01at,
  with_0 as with1ezpy3gn0rpui,
};
//endregion

//# sourceMappingURL=PartyId.mjs.map
